import apiClient from '@/services/rest-api-vsms/apiClient'

const baseEndpoint = '/product-categories'

export const get = async () => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}`,
  })

  return response?.data
}

export const getById = async (id) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${id}`,
  })

  return response?.data
}
